import React, { Suspense } from 'react';
import { Toaster } from 'sonner';
import ScrollToTop from './components/ScrollToTop.jsx';
import Seo from './components/Seo.jsx';
import AppRoutes from './routes.jsx';

function AppShell({ isPrerender = false }) {
  return (
      <>
        <Seo />
        {!isPrerender && <ScrollToTop />}
        {!isPrerender && <Toaster position="top-center" richColors />}
        <Suspense fallback={!isPrerender ? <div className="min-h-screen bg-background" aria-hidden="true" /> : null}>
          <AppRoutes />
        </Suspense>
      </>
  );
}

export default AppShell;
